import React from 'react';

type WhatsNewModalProps = {
  open: boolean;
  onClose: () => void;
};

const releaseHighlights = [
  {
    title: 'Automatisk versionssporing',
    description:
      'Appen kender nu sin egen version og viser den tydeligt i navigationen, så support og brugere nemt kan se, hvad der kører.',
  },
  {
    title: 'PWA-opdateringer uden datatab',
    description:
      'Når en ny version er klar, viser vi en sikker toast, der tilbyder opdatering uden at tvinge siden til at genindlæse.',
  },
  {
    title: 'Release logik pr. version',
    description:
      '“What’s new”-dialogen åbner kun, når versionen ændrer sig, og lader dig også åbne den manuelt fra navigationen.',
  },
];

export function WhatsNewModal({ open, onClose }: WhatsNewModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[13000] flex items-center justify-center bg-black/60 px-4 py-8">
      <div className="w-full max-w-lg rounded-3xl border border-app-border bg-app-surface shadow-2xl p-6 flex flex-col gap-6">
        <header className="space-y-1">
          <p className="text-xs uppercase tracking-[0.2em] text-app-text-tertiary">
            Release notes
          </p>
          <h2 className="text-2xl font-semibold text-app-text">Det nyeste i Min Tryg Hånd</h2>
          <p className="text-sm text-app-text-secondary">
            Version {__APP_VERSION__}
          </p>
        </header>

        <div className="space-y-4 text-sm">
          {releaseHighlights.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-app-border bg-app-secondary/40 p-4"
            >
              <h3 className="text-base font-semibold text-app-text">{item.title}</h3>
              <p className="mt-1 text-app-text-secondary">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-app-primary px-6 py-2 text-sm font-semibold text-white hover:opacity-90 transition"
          >
            Forstået
          </button>
        </div>
      </div>
    </div>
  );
}






